var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMakeShortericon = function SvgMakeShortericon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.05 4.725h11.9a.35.35 0 0 1 .35.35v.7a.35.35 0 0 1-.35.35H1.05a.35.35 0 0 1-.35-.35v-.7a.35.35 0 0 1 .35-.35Zm8.05 4.55H1.05a.35.35 0 0 1-.35-.35v-.7a.35.35 0 0 1 .35-.35H9.1a.35.35 0 0 1 .35.35v.7a.35.35 0 0 1-.35.35Z",
    clipRule: "evenodd"
  })));
};
export default SvgMakeShortericon;